var View = require('views/base/view');

var ChecklistItemView = View.extend({
  autoRender: true,
  template: require('./templates/checklist-item')
});

module.exports = ChecklistItemView;